export const breaks = [
  {
    startTime: '07:30',
    groupedTalks: [{ startTime: '07:30', isBreak: true, title: 'Registrations and Breakfast' }]
  },
  {
    startTime: '10:00',
    groupedTalks: [
      {
        startTime: '10:00',
        isBreak: true,
        title: 'Networking Coffee Break, Demo Time in Exhibition Area'
      }
    ]
  },
  {
    startTime: '11:10',
    groupedTalks: [{ startTime: '11:10', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '12:00',
    groupedTalks: [{ startTime: '12:00', isBreak: true, title: 'Lunch Break' }]
  },
  {
    startTime: '13:40',
    groupedTalks: [{ startTime: '13:40', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '14:30',
    groupedTalks: [
      { startTime: '14:30', isBreak: true, title: 'Expert Discussions, Exhibition Area' }
    ]
  },
  {
    startTime: '15:40',
    groupedTalks: [{ startTime: '14:40', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '16:30',
    groupedTalks: [{ startTime: '16:30', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '17:20',
    groupedTalks: [{ startTime: '17:20', isBreak: true, title: 'Conference Closing' }]
  }
];

export const placeholders = [
  {
    startTime: '10:30',
    groupedTalks: [
      { startTime: '10:30', trackInDay: 6, title: 'Closed', tileRole: 'CLOSED', id: '11' }
    ]
  },
  {
    startTime: '13:50',
    groupedTalks: [
      {
        startTime: '13:50',
        trackInDay: 6,
        title: 'Panel discussion: Balancing Innovation and Caution in New Era of AI',
        tileRole: 'CLOSED',
        id: '12'
      }
    ]
  },
  {
    startTime: '15:50',
    groupedTalks: [
      { startTime: '15:50', trackInDay: 6, title: 'Closed', tileRole: 'CLOSED', id: '21' }
    ]
  },
  {
    startTime: '16:40',
    groupedTalks: [
      { startTime: '16:40', trackInDay: 2, title: 'Closed', tileRole: 'CLOSED', id: '22' },
      { startTime: '16:40', trackInDay: 4, title: 'Closed', tileRole: 'CLOSED', id: '23' },
      { startTime: '16:40', trackInDay: 5, title: 'Closed', tileRole: 'CLOSED', id: '24' },
      { startTime: '16:40', trackInDay: 6, title: 'Closed', tileRole: 'CLOSED', id: '25' }
    ]
  }
];

export const workshopPlaceholders = [
  {
    startTime: '08:30',
    groupedTalks: [
      {
        startTime: '08:30',
        trackInDay: 5,
        title: 'Closed',
        tileRole: 'CLOSED',
        id: '1',
        room: 'FEI D2 - Accenture Campus Lab'
      }
    ]
  },
  {
    startTime: '12:00',
    groupedTalks: [
      {
        startTime: '12:00',
        trackInDay: 4,
        title: 'Closed',
        tileRole: 'CLOSED',
        id: '13',
        room: 'B-klub'
      }
    ]
  },
  {
    startTime: '15:30',
    groupedTalks: [
      {
        startTime: '15:30',
        trackInDay: 5,
        title: 'Closed',
        tileRole: 'CLOSED',
        id: '12',
        room: 'FEI D2 - Accenture Campus Lab'
      }
    ]
  }
];

export const conferenceOpening = {
  startTime: '08:45',
  endTime: '09:00',
  title: 'Conference Opening',
  room: '',
  track: 'Talk',
  isConferenceOpening: true,
  youtube: '',
  speakers: [
    { id: '1', name: 'Tomas Volek', company: 'Accenture', country: 'Slovakia' },
    { id: '2', name: 'Martin Donoval', company: 'FEI STU', country: 'Slovakia' },
    { id: '3', name: 'Zdeňka van der Zwan', company: 'Red Hat', country: 'Czech Republic' }
  ],
  trackInDay: 1
};

export default {
  breaks,
  placeholders,
  conferenceOpening,
  workshopPlaceholders
};
